import { render, staticRenderFns } from "./MyCheckBox.vue?vue&type=template&id=b1f517c2&scoped=true"
import script from "./MyCheckBox.vue?vue&type=script&lang=js"
export * from "./MyCheckBox.vue?vue&type=script&lang=js"
import style0 from "./MyCheckBox.vue?vue&type=style&index=0&id=b1f517c2&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f517c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f517c2')) {
      api.createRecord('b1f517c2', component.options)
    } else {
      api.reload('b1f517c2', component.options)
    }
    module.hot.accept("./MyCheckBox.vue?vue&type=template&id=b1f517c2&scoped=true", function () {
      api.rerender('b1f517c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyCheckBox.vue"
export default component.exports